fragment CampaignFragment on Campaign {
    id
    type
    name
    htmlUrlPath
    status
    creatorUser {
        id
        name
    }
    owner {
        id
        name
    }
    createdTime
    deletedTime
    nextSendingEdition {
        id
        name
        scheduledTime
        htmlUrlPath
    }
}
